import { Component, Input } from '@angular/core';
import { TIME_FORMAT } from 'src/app/core/ccomx-date-formats';
import { IDepartmentPauseLogDisplayRow } from 'src/app/department/models/department-pause.model';
import {
  DepartmentPauseLogState,
  departmentPauseLogReasonLabels,
  departmentPauseLogStateLabels,
} from 'src/app/shared/enums/department-pause-log.enum';

@Component({
  selector: 'app-department-pause-log-template',
  templateUrl: './department-pause-log-template.component.html',
  styleUrls: ['./department-pause-log-template.component.scss'],
  standalone: false,
})
export class DepartmentPauseLogTemplateComponent {
  @Input() columnName: string;
  @Input() element: IDepartmentPauseLogDisplayRow;

  timeFormat = TIME_FORMAT;
  pauseReasonLabels = departmentPauseLogReasonLabels;
  pauseStateLabels = departmentPauseLogStateLabels;

  getPauseStatePillName(state: DepartmentPauseLogState | undefined): string {
    switch (state) {
      case DepartmentPauseLogState.Scheduled:
        return 'inprogress';
      case DepartmentPauseLogState.Active:
        return 'ok';
      case DepartmentPauseLogState.Finished:
        return 'completed';
      case DepartmentPauseLogState.Canceled:
        return 'rejected';
      case DepartmentPauseLogState.Finishing:
        return 'implementing';
      default:
        return '';
    }
  }
}
